var _defs, _rect, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 246.82 86.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#43b049;}.cls-3{fill:#fff;}.cls-4{fill:#183129;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 246.82,
    height: 86.72
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23.7 23.69 23.7 23.69 67.66 23.69 67.66 63.02 23.7 63.02 23.7 23.69 23.7 23.69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.61,32h0c5.88,0,10.24-1.28,10.24-11.78,0-8-2.92-11.13-9.05-11.13H5.36v3.27h7.47V32h5.09V12.34H29.21c3.46,0,5.1,1.78,5.1,7.92s-1.43,8.46-4.85,8.46H24.51V13.53H19.37V32H29.61Z",
    transform: "translate(22.95 22.53)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.66,25.15V23h0a3.74,3.74,0,0,1-3.87,2.48c-3.85,0-5.27-3-5.27-6.5,0-3.26,1.5-6.11,5.11-6.11a4.05,4.05,0,0,1,3.62,1.83h0V7.81h5.8V25.15h-5.39Zm-1.73-8.72c-1.22,0-1.43,1.25-1.43,2.5s0.21,2.61,1.47,2.61,1.43-1.34,1.43-2.47C179.41,17.68,179.22,16.43,177.93,16.43Z",
    transform: "translate(22.95 22.53)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60.21,9.06h8.5l5.73,16.08H68l-1.06-3.48H61.7l-1,3.48H54.57Zm2.35,8.73h3.57l-1.75-5.27h0Z",
    transform: "translate(22.95 22.53)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.37,13.13h5.48v2.07h0A4.06,4.06,0,0,1,85,12.86c1.61,0,3.29.62,3.76,2.05h0c0.39-1.38,2.42-2.05,3.85-2.05,4.24,0,4.24,2.74,4.24,5.09v7.19h-5.8V18.23c0-.69,0-1.63-1-1.63s-1,.94-1,1.63v6.91h-5.8V18.23c0-.69,0-1.63-1-1.63s-1,.94-1,1.63v6.91h-5.8v-12Z",
    transform: "translate(22.95 22.53)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104,20.53c0.09,1.5,1.5,1.84,3.2,1.84a8.93,8.93,0,0,0,3.94-.76v3.11a18.51,18.51,0,0,1-5.41.69c-4.86,0-7.44-2.35-7.44-6.49s2.58-6.06,7.44-6.06c4.65,0,6.29,2.9,6.29,7v0.71h-8ZM107,18c0-.92-0.14-2.37-1.45-2.37s-1.63,1.43-1.56,2.37h3Z",
    transform: "translate(22.95 22.53)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119,13.13v2.72h0c0.69-1.7,1.84-3,3.66-3a3.74,3.74,0,0,1,.94.11v4.81a4,4,0,0,0-1.31-.18,3.08,3.08,0,0,0-3,3.18v4.35h-5.8v-12H119Z",
    transform: "translate(22.95 22.53)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.15,11.87h-5.8v-4h5.8v4Zm-5.8,1.26h5.8v12h-5.8v-12Z",
    transform: "translate(22.95 22.53)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.71,13.13V10.37l5.8-1.77v4.54h2.63v3.46h-2.63V20a1.32,1.32,0,0,0,1.27,1.57,4.15,4.15,0,0,0,1.36-.21v3.46a14,14,0,0,1-4,.62c-3,0-4.45-1.5-4.45-4.67V16.59h-2.05V13.13h2.05Z",
    transform: "translate(22.95 22.53)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.24,13.13v2.72h0c0.69-1.7,1.85-3,3.66-3a3.73,3.73,0,0,1,.94.11v4.81a4,4,0,0,0-1.31-.18,3.09,3.09,0,0,0-3,3.18v4.35h-5.8v-12h5.44Z",
    transform: "translate(22.95 22.53)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.75,13.55a15.54,15.54,0,0,1,5-.69c3.32,0,7.35.6,7.35,5v7.3h-5.39V23.41h0a4.36,4.36,0,0,1-3.92,2c-2.23,0-4.4-1-4.4-3.52,0-3.69,3.31-4.42,6.2-4.42,0.8,0,1.73.12,2.26,0.16,0-1.54-1.61-1.73-3.06-1.73a9.36,9.36,0,0,0-4,1V13.55Zm7.07,6.31h-0.58c-1.2,0-2.58.11-2.58,1.36A1.1,1.1,0,0,0,162,22.37a1.94,1.94,0,0,0,1.79-2.14V19.86Z",
    transform: "translate(22.95 22.53)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.15,20.48c0.09,1.5,1.5,1.84,3.2,1.84a9,9,0,0,0,3.94-.76v3.11a18.53,18.53,0,0,1-5.41.69c-4.86,0-7.44-2.35-7.44-6.49s2.58-6.06,7.44-6.06c4.65,0,6.29,2.9,6.29,7v0.71h-8Zm3-2.53c0-.92-0.14-2.37-1.45-2.37s-1.63,1.43-1.56,2.37h3Z",
    transform: "translate(22.95 22.53)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTd);
export default __webpack_public_path__ + "static/media/td.0e0ceb31e0f6de69efaec3620dec9acc.svg";
export { ForwardRef as ReactComponent };